/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_New_ProjectInputs */

const en_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the New Project window`)
};

const fr_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la fenetre Nouveau projet`)
};

const de_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie das Fenster „Neues Projekt“.`)
};

const it_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la finestra Nuovo progetto`)
};

const ru_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте окно «Новый проект».`)
};

const es_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la ventana Nuevo proyecto`)
};

const zh_cn2_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开“新建项目”窗口`)
};

const ja_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロジェクトウィンドウを開く`)
};

const hi_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया प्रोजेक्ट विंडो खोलें`)
};

const pt_pt2_shortcut_keys_desc_new_project = /** @type {(inputs: Shortcut_Keys_Desc_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra a janela Novo Projeto.`)
};

/**
* | output |
* | --- |
* | "Open the New Project window" |
*
* @param {Shortcut_Keys_Desc_New_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_new_project = /** @type {((inputs?: Shortcut_Keys_Desc_New_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_New_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_new_project(inputs)
	if (locale === "de") return de_shortcut_keys_desc_new_project(inputs)
	if (locale === "it") return it_shortcut_keys_desc_new_project(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_new_project(inputs)
	if (locale === "es") return es_shortcut_keys_desc_new_project(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_new_project(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_new_project(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_new_project(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_new_project(inputs)
	return en_shortcut_keys_desc_new_project(inputs)
});